export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/teams', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/team', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/team/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/team/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/team/' + data.id, { params: data.filters || {} })
  }
})
